import { Operation } from '@apollo/client'

import { requestIdHeader } from '.'

export const getOperationErrorProperties = (operation: Operation) => {
  if (!operation) return {}

  const requestId = operation?.getContext()?.headers?.[requestIdHeader]
  return {
    requestId,
    operation: operation?.operationName,
    query: operation?.query?.loc?.source?.body,
    variables: operation?.variables
  }
}
